var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9728 12.5L10.9745 8.99993C10.9736 8.07377 11.6458 7.32217 12.4758 7.3212H12.4773C13.3083 7.3212 13.9819 8.07283 13.9819 9L13.9835 9.99993M13.9835 9.99993V12.5M13.9835 9.99993C13.9827 9.07377 14.6548 8.32217 15.4849 8.3212H15.4864C16.3173 8.3212 16.9909 9.07283 16.9909 10V11.1788M16.9909 12.5L16.9926 11.1787C16.9917 10.2526 17.6639 9.50097 18.4939 9.5H18.4954C19.3264 9.5 20 10.2516 20 11.1788L19.9999 17.0001C19.9998 19.2092 18.209 21 15.9999 21H7.9832C7.9832 21 2.84504 13.7128 2.36312 13.0797C1.64025 12.1299 1.9438 11.0567 3.75285 11.0567C5.56185 11.0567 6.60515 14.0103 7.9832 14.0103C7.99142 14.0122 7.99197 10.235 7.98486 3.67873C7.984 2.75257 8.65615 2.00097 9.4862 2H9.48771C10.3187 2 10.9923 2.75163 10.9923 3.6788V11.3212",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand2);
export default __webpack_public_path__ + "static/media/hand2.025a5a3d02cbbabf9af5ada1bc7d6336.svg";
export { ForwardRef as ReactComponent };